"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var SitecoreContextFactory = /** @class */ (function () {
    function SitecoreContextFactory() {
        this.subscribers = [];
        this.context = {
            pageEditing: false,
        };
    }
    SitecoreContextFactory.prototype.getSitecoreContext = function () {
        return this.context;
    };
    SitecoreContextFactory.prototype.subscribeToContext = function (func) {
        this.subscribers.push(func);
    };
    SitecoreContextFactory.prototype.unsubscribeFromContext = function (func) {
        var index = this.subscribers.indexOf(func);
        if (index >= 0) {
            this.subscribers.splice(index, 1);
        }
    };
    SitecoreContextFactory.prototype.setSitecoreContext = function (value) {
        this.context = value;
        this.subscribers.forEach(function (func) { return func(value); });
    };
    return SitecoreContextFactory;
}());
exports.SitecoreContextFactory = SitecoreContextFactory;
exports.SitecoreContextReactContext = react_1.default.createContext({});
exports.ComponentFactoryReactContext = react_1.default.createContext({});
var SitecoreContext = /** @class */ (function (_super) {
    __extends(SitecoreContext, _super);
    function SitecoreContext(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.contextListener = function () { return _this.forceUpdate(); };
        _this.componentFactory = props.componentFactory;
        if (props.contextFactory) {
            _this.contextFactory = props.contextFactory;
        }
        else {
            _this.contextFactory = new SitecoreContextFactory();
        }
        return _this;
    }
    SitecoreContext.prototype.componentDidMount = function () {
        // we force the children of the context to re-render when the context is updated
        // even if the local props are unchanged; we assume the contents depend on the Sitecore context
        this.contextFactory.subscribeToContext(this.contextListener);
    };
    SitecoreContext.prototype.componentWillUnmount = function () {
        this.contextFactory.unsubscribeFromContext(this.contextListener);
    };
    SitecoreContext.prototype.render = function () {
        return (react_1.default.createElement(exports.ComponentFactoryReactContext.Provider, { value: this.componentFactory },
            react_1.default.createElement(exports.SitecoreContextReactContext.Provider, { value: this.contextFactory }, this.props.children)));
    };
    SitecoreContext.propTypes = {
        children: prop_types_1.default.any.isRequired,
        componentFactory: prop_types_1.default.func,
        contextFactory: prop_types_1.default.object,
    };
    SitecoreContext.displayName = 'SitecoreContext';
    return SitecoreContext;
}(react_1.default.Component));
exports.SitecoreContext = SitecoreContext;
